// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__228Ad","header":"ReportDetails_header__i_DP5","title":"ReportDetails_title__14SEa","left":"ReportDetails_left__2oLuk"};